import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'

import classes from './GaDivider.module.scss'

/** @type {import("./types").default} */
const GaDivider = ({ className, ...props }) => (
  <p className={clsx('GaDivider', classes.root, className)} {...props}>
    <Icon prefix="ga" icon="logo-square" size={24} />
  </p>
)

export default GaDivider
